const currentSummary = state => state.currentSummary
const estimatedSummary = state => state.estimatedSummary
const regions = state => state.regions
const products = state => state.products
const months = state => state.months
const weeks = state => state.weeks
const dates = state => state.dates
const status = state => state.status
const detail = state => state.detail
const hasInvoice = state => state.hasInvoice
const downloadLoadingSimple = state => state.downloadLoading.simpleExcel
const downloadLoadingDetail = state => state.downloadLoading.detailCSV
const downloadLoadingInvoice = state => state.downloadLoading.invoicePDF
export default {
    currentSummary,
    estimatedSummary,
    regions,
    products,
    months,
    weeks,
    dates,
    status,
    detail,
    hasInvoice,
    downloadLoadingSimple,
    downloadLoadingDetail,
    downloadLoadingInvoice
}
